import 'babel-polyfill'
